<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <v-text-field
            v-model="username"
            :rules="obligatorio"
            label="Nombre de usuario"
            required
            variant="solo"
        ></v-text-field>
        <FacturadoresTotSelect
            @facturador-seleccionado="facturadorId = $event">
        </FacturadoresTotSelect>
        <v-btn
            :disabled="!valid"
            id="boton-verde"
            :loading="cargando"
            type="submit"
        >
        {{this.desasociar ? 'Desasociar' : 'Asociar'}}
        </v-btn>
    </v-form>
    <ClosableAlert
        v-if="alert"
        :type="alertType"
        :key="alertKey"
        :texto="mensaje"
        :titulo="desasociar ? 'Desasociar usuario a facturador' : 'Asociar usuario a facturador'"
    ></ClosableAlert>
</template>
<style src="../assets/general.css"></style>
<script>
    import ClosableAlert from './ClosableAlert.vue';
    import { obligatorio } from '@/_helpers/rules';
    import AuthService from '@/api/AuthService';
    import FacturadoresTotSelect from './FacturadoresTotSelect.vue';

    const authService = new AuthService();

    export default {
        components: {
            ClosableAlert,
            FacturadoresTotSelect
        },
        props: {
            desasociar: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                valid: false,
                cargando: false,
                username: '',
                facturadorId: null,
                // alert
                alert: false,
                alertType: '',
                mensaje: '',
                alertKey: 0
            }
        },
        methods: {
            async handleSubmit(){
                this.cargando = true;
                const responseUsuario = await authService.buscarUsuario(this.username);
                if(responseUsuario && responseUsuario.status == 200){
                    const idUsuario = responseUsuario.data.id;
                    let response;
                    if(this.desasociar){
                        response = await authService.eliminarUsuNivFact(idUsuario, this.facturadorId);
                    } else {
                        response = await authService.crearUsuNivFact(idUsuario, this.facturadorId);
                    }
                    if(response && response.status == 200){
                        this.alertType = 'success';
                        this.mensaje = this.desasociar ? "Usuario desasociado correctamente" : "Usuario asociado correctamente";
                    } else {
                        this.alertType = 'error';
                        this.mensaje = this.desasociar ? "Error al desasociar usuario" : "Error al asociar usuario";
                    }
                } else{
                    this.alertType = 'error';
                    this.mensaje = "Usuario no encontrado";
                }
                this.alert = true;
                this.alertKey+= 1;
                this.cargando = false;
            }
        }
    }
</script>